import { isDebugger } from 'common/debugger'
import { getUnprefixedItemAndParse } from 'common/using-local-storage-key'
import { clientId } from 'common/client-id'

export function getNamespacedKey(key) {
    let user = getUnprefixedItemAndParse('currentAuthenticatedUser')?.id || clientId
    const prefix = isDebugger() ? 'debugger-' : ''
    return `${prefix}${user}${key}`
}
